import React, { Component } from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'
import './thumbnail.css'

export default class Thumbnail extends Component {
    render() {
        return (
            <img src={this.props.image} className={className('thumbItem', this.props.selected ? "selected" : "")} role="presentation" />
        )
    }
}

Thumbnail.propTypes = {
    image: PropTypes.string.isRequired,
    selected: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/thumbnail.js